import React from 'react';
import { useFormContext } from 'react-hook-form';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import ControlledSelect from '@/components/common/form/ControlledSelect';
import ControlledStartEndDateInputs from '@/components/common/form/ControlledStartEndDateInputs';
import BirthdateMonthOptions from '@/constants/BirthdateMonthOptions';
import useStatefulId from '@/lib/hooks/useStatefulId';
import translate from '@/lib/intl/translate';

function ConstituentBirthdateFilters({
  monthFieldName = 'birthdayMonth',
  bornAfterFieldName = 'bornAfterDate',
  bornBeforeFieldName = 'bornBeforeDate',
}: {
  monthFieldName?: string;
  bornAfterFieldName?: string;
  bornBeforeFieldName?: string;
}) {
  const {
    control,
    formState: { errors },
    trigger,
    watch,
  } = useFormContext();
  const id = useStatefulId();
  const monthValue = watch(monthFieldName);
  return (
    <div className="grid auto-rows-auto grid-cols-1 gap-4">
      <FormControl className="w-full" size="small">
        <InputLabel id={`${id}-month-label`} shrink={!!monthValue}>
          {translate('FORMS_BIRTHDATE_MONTH_LABEL')}
        </InputLabel>
        <ControlledSelect
          labelId={`${id}-month-label`}
          control={control}
          name={monthFieldName}
          label={translate('FORMS_BIRTHDATE_MONTH_LABEL')}
          renderValue={(selected) =>
            selected ? (
              <div className="max-w-full truncate">
                {
                  BirthdateMonthOptions.find(({ value }) => value === selected)
                    ?.text
                }
              </div>
            ) : (
              ''
            )
          }
        >
          {BirthdateMonthOptions.map(({ value, text }) => (
            <MenuItem key={value} value={value}>
              {text}
            </MenuItem>
          ))}
        </ControlledSelect>
      </FormControl>

      <div className="flex flex-wrap">
        <ControlledStartEndDateInputs
          control={control}
          classes={{
            endInputContainer: 'flex-grow md:flex-1 md:w-1/2 md:ml-2',
            startInputContainer:
              'mb-4 flex-grow md:flex-1 md:w-1/2 md:mr-2 md:mb-0',
          }}
          endDateLabel={translate('FORMS_BIRTHDATE_BORN_BEFORE_LABEL')}
          endDateName={bornBeforeFieldName}
          errors={errors}
          id="constituent-filter-birthdate-picker"
          startDateLabel={translate('FORMS_BIRTHDATE_BORN_AFTER_LABEL')}
          startDateName={bornAfterFieldName}
          trigger={trigger}
          watch={watch}
        />
      </div>
    </div>
  );
}

export default ConstituentBirthdateFilters;
